module.exports = __webpack_public_path__ + "static/media/rxjs.f7177acb.svg";